export const LIQUIDATION_EXPORT_ID = "Reporte - Liquidaciones";
export const LIQUIDATION_TITLE = "Reporte - Liquidaciones";

export const LIQUIDATION_PROPERTIES = {
    trip: "Viaje",
    subRoute: "Ruta",
    vehicleName: "Vehículo",
    serial: "No. Documento",
    username: "Usuario",
    companyName: "Compañia",
    salesOfficeName: "Oficina de ventas",
    createdAt: "Fecha de creación",
    materialCode: "Código de material",
    materialName: "Nombre de material",
    loaded: 'Cargado',
    delivered: 'Entregado/Facturado',
    returnedBE: 'Buen Estado',
    returnedME: 'Mal Estado',
    missing: 'Faltante',
};